import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import './Menu.scss';
import './callout.scss';
import SubmenuList from './SubmenuList';
// import AccordionContent from './AccordionContent';
import Arbutton from './Arbutton'; // Added AR button import
import Badges from '../Badges/Badge'; // Adjust path if needed
import Dimensions from "../Dimensions/Dimensions"; // Added for accordion-level dimensions

const Menu = (props) => {
  const { handleHotspotClick = () => console.warn("handleHotspotClick not provided") } = props;

  let menuList = [...props.menuSubmenu];
  let productTypeMenu = [];
  let QRSupport = props.QRSupport;
  let { QR, ReduceTransitions } = { ...props.ui };
  let onLoadActiveAccordionMobile = props.onLoadActiveAccordionMobile;

  const [activeBadgesInfo, setActiveBadgesInfo] = useState(null);
  // const [activeAccordionId, setActiveAccordionId] = useState(null);

  const [activeAccordionId, setActiveAccordionId] = useState(() => {
    if (window.isMobIsipadIsPotrait) {
      return props.menuSubmenu?.[0]?.id || null; // e.g., "Exploded_View"
    }
    return null;
  });

  let filterMenuBasedOnConfigType = props.filterMenuBasedOnConfigType;

  let cssVariableValues = props.cssVariableValues;
  let accordionMenuTextWidth =
    parseInt(cssVariableValues.menuWidth) -
    (parseInt(cssVariableValues.accordionMenuPaddingLeft) +
      parseInt(cssVariableValues.accordionMenuPaddingRight) +
      parseInt(cssVariableValues.accordionMenuIconWidth) +
      parseInt(cssVariableValues.accordionMenuIconMarginLeft) +
      parseInt(cssVariableValues.accordionMenuIconMarginRight) +
      parseInt(cssVariableValues.accordionMenuChevronWidth) +
      parseInt(cssVariableValues.accordionMenuChevronMarginLeft));
  let qrTextWidth = parseInt(cssVariableValues.menuWidth) - parseInt(cssVariableValues.menuFooterPaddingLeftRight) * 2;

  let qrTextContentwidth = props.calcHtmlElementNoWrapWidth(QR, cssVariableValues.qrTextFontSize);
  let adjuestedWidth = window.UiUtils.checkIfWidthNeedUpdate(qrTextContentwidth, qrTextWidth, cssVariableValues.qrTextFontSize);

  const toggleBadgeVisibility = (item) => {
    if (item?.badgesInfo?.badge) {
      setActiveBadgesInfo(item.badgesInfo);
    } else {
      setActiveBadgesInfo(null);
    }
  };

  useEffect(() => {
    window.toggleBadgeVisibility = toggleBadgeVisibility;
  }, []);

  const handleSubMenuClickEnhanced = (item, e) => {
    props.handleSubMenuClick(item, e);
    toggleBadgeVisibility(item);
  };

  const handleMainMenuClick = (item) => {
    const hasContent = (Array.isArray(item.content) && item.content.length > 0)
      || (item.hotspotDataInfo && item.hotspotDataInfo.length > 0); // include hotspot data

    setActiveAccordionId(prev => {
      // Toggle only if the item has content or hotspot info
      if (!hasContent) return null;

      // Toggle pattern: hide → show → hide → show
      return prev === item.id ? null : item.id;
    });

    props.accordionMenuclick(item, "accordion_" + item.id);
    toggleBadgeVisibility(item);
  };

  if (window.isMobIsipadIsPotrait) {
    menuList = menuList.filter((list) => list.id !== "ProductType");
    productTypeMenu = props.menuSubmenu.filter((list) => list.id === "ProductType");
  }
  if (productTypeMenu.length === 1) productTypeMenu = productTypeMenu[0];

  // QR code and URL setup
  if (window.location.href) {
    let url = window.location.href.split('?')[0];
    if (!url.endsWith('index.html')) {
      if (!url.endsWith('/')) url += '/';
      url += 'index.html';
    }
    let params = window.location.href.split('?')[1];
    let newParames = '?qr=1';
    if (params !== undefined && !params.includes('qr=')) newParames = newParames + '&' + params;
    else if (params !== undefined && params.includes('qr=')) newParames = '?' + params;
    url = url + newParames;

    if (params !== undefined && params.includes('contentURL=')) {
      let contentURL = params.split('contentURL=')[1];
      url = contentURL + '?qr=1';
    }

    window.linkForGenerateQR = `${url}`;
  }



// add accordion click hotspot commented because on next click it close
  let filteredMenuList = menuList.filter(filterMenuBasedOnConfigType);
  window.selectedConfig['menuList'] = [...filteredMenuList];
  window.config.nextPrevArray = [];

  filteredMenuList.forEach((accordion) => {
    // Add the accordion itself
    if (!window.config.nextPrevArray.find(e => e.id === accordion.id)) {
      window.config.nextPrevArray.push(accordion);
    }

    // Add any hotspots for this accordion first (before submenu items)
    if (accordion.hotspotDataInfo && Array.isArray(accordion.hotspotDataInfo) && accordion.hotspotDataInfo.length > 0) {
      accordion.hotspotDataInfo.forEach((dim) => {
        window.config.nextPrevArray.push({
          ...dim,
          type: 'dimension',
          id: dim.htmlid || dim.hsname,
          parentSubmenuId: accordion.id
        });
      });
    }

    // Add accordion's submenu items
    if (accordion.items && accordion.items.length) {
      accordion.items.forEach((item) => {
        if (!window.config.nextPrevArray.find(e => e.id === item.id)) {
          window.config.nextPrevArray.push(item);

          // Add hotspot dimensions for each item
          if (item.hotspotDataInfo && Array.isArray(item.hotspotDataInfo) && item.hotspotDataInfo.length > 0 && window.config.dimensions) {
            item.hotspotDataInfo.forEach((dim) => {
              window.config.nextPrevArray.push({
                ...dim,
                type: 'dimension',
                id: dim.htmlid || dim.hsname,
                parentSubmenuId: item.id
              });
            });
          }
        }
      });
    }
  });


  window.menuSubmenuTabindex = 6;
  let menuIndex = window.menuSubmenuTabindex;

  return (
    <>
      <nav id="mainMenu" className="menuContainer expanded">
        {/* Product type button for mobile */}
        {productTypeMenu.length === undefined && window.isMobIsipadIsPotrait && (
          <div className="productTypeBtn">
            <img className="icon" src={productTypeMenu.iconMobile} />
            <span className="productTypeMenuTitle">{productTypeMenu.mobileTitle}</span>
            <ul className="productTypeList">
              {productTypeMenu.items.map((item) => {
                let isActive = window.selectedConfig[item.featureType] === item.id;
                return (
                  <li
                    key={item.id}
                    className="subMenuBtn radioButton mob"
                    id={`menu_id_${item.id}`}
                    onClick={(e) => {
                      props.handleSubMenuClick(item, e);
                      toggleBadgeVisibility(item);
                    }}
                  >
                    <label>
                      <input type="radio" name={item.radioName} value={item.id} defaultChecked={isActive} />
                    </label>
                    <span className="mobRadioTitle"> {item.mobileTitle} </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <ul>
          {filteredMenuList.map((list, listIndex) => {
            const isLastItem = listIndex === filteredMenuList.length - 1;
            const isArpopup = list.id === "arpopup";

            // Mobile AR fix: show only button in mobile portrait
            if (isArpopup && isLastItem && window.isMobIsipadIsPotrait) {
              return (
                <li key="mobile-ar-btn" className="accordionMenu arButtonMobile" tabIndex={0}>
                  <Arbutton ui={props.ui} calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth} />
                </li>
                
              );
            }
   let isFirstAccordion = props.isFirstAccordion;
            // const isAccordionActive = activeAccordionId === list.id;
               let isAccordionActive = (isFirstAccordion && window.isMobIsipadIsPotrait && listIndex == 0) || (!isFirstAccordion && window.isMobIsipadIsPotrait && listIndex == 0 && window.selectedConfig.selectedAccordion === undefined) || (!isFirstAccordion && window.selectedConfig.selectedAccordion !== undefined && window.selectedConfig.selectedAccordion.includes("accordion_"+list.id));

            return (
              <React.Fragment key={list.id}>
                <li
                  id={"accordion_" + list.id}
                  role="button"
                  className={isAccordionActive ? "accordionMenu active" : "accordionMenu"}
                  onClick={() => handleMainMenuClick(list)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleMainMenuClick(list);
                  }}
                  tabIndex={0}
                >
                  <img className="icon" src={window.isMobIsipadIsPotrait ? list.mobIcon : list.icon} />
                  <span
                    className="text"
                    data-width={accordionMenuTextWidth}
                    data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, cssVariableValues.accordionMenuTextFontSize)}
                  >
                    {!window.isMobIsipadIsPotrait ? list.title : list.mobileTitle}
                  </span>
                  <svg viewBox="0 0 32 32" className="chevron" aria-hidden="true" focusable="false">
                    <path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path>
                  </svg>
                </li>

                {list.items && (
                  <>
                    <SubmenuList
                      count={props.count}
                      accordionId={"accordion_" + list.id}
                      parentIndex={menuIndex}
                      activeAccordionId={activeAccordionId}
                      accordionData={list}
                      subMenuList={list.items}
                      handleSubMenuClick={handleSubMenuClickEnhanced}
                      handleHotspotClick={handleHotspotClick}
                      filterMenuBasedOnConfigType={filterMenuBasedOnConfigType}
                      calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth}
                      cssVariableValues={cssVariableValues}
                    />
                    {/* <AccordionContent
                      accordionContentList={list.items}
                      accordionData={list}
                      filterMenuBasedOnConfigType={filterMenuBasedOnConfigType}
                      activeAccordionId={activeAccordionId}
                      accordionId={"accordion_" + list.id}
                      cssVariableValues={cssVariableValues}
                      calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth}
                    /> */}

                    {/* FIXED: Accordion-level Dimensions - sirf items wale block ke andar */}
                    {list.hotspotDataInfo && Array.isArray(list.hotspotDataInfo) && list.hotspotDataInfo.length > 0 && !window.isMobIsipadIsPotrait && (
                      <Dimensions
                        list={list}
                        handleHotspotClick={handleHotspotClick}
                      />
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </ul>

        {/* Badges */}
        {(!window.isMobIsipadIsPotrait) && (
          <Badges badgesInfo={activeBadgesInfo} />
        )}
      </nav>
    </>
  );
};

export default Menu;
